import type { LanguageCode } from "config/languages";
import { getLocaleByLanguage } from "utils/localeUtils";
import type { CompensationValues, Currencies, CurrenciesConfig } from "./currencies.d";
import { getCurrencyFormatException, getCurrencyFromLanguage } from "./currencyUtils";

export const euroSign = "€";
export const defaultCurrency = "EUR";

export const nonEURlanguages: CurrenciesConfig = {
  en: "USD",
  "en-au": "USD",
  "en-ca": "USD",
  "en-gb": "GBP",
  "en-in": "USD",
  "en-nz": "USD",
  "pt-br": "BRL",
  "fr-ca": "USD",
};

export const compensationValues: CompensationValues = {
  EUR: {
    compensation: 600,
    ec261Compensation: 600,
    luggage: 1400,
    extraExpenses: 6000,
    brazilCompensation: 1800,
    uk261Compensation: 600,
  },
  GBP: {
    compensation: 520,
    ec261Compensation: 520,
    luggage: 1200,
    extraExpenses: 5300,
    brazilCompensation: 1500,
    uk261Compensation: 520,
  },
  USD: {
    compensation: 700,
    ec261Compensation: 700,
    luggage: 1700,
    extraExpenses: 7000,
    brazilCompensation: 1800,
    uk261Compensation: 600,
  },
  BRL: {
    compensation: 10000,
    ec261Compensation: 3000,
    luggage: 9000,
    extraExpenses: 39000,
    brazilCompensation: 10000,
    uk261Compensation: 3000,
  },
};

export const ourFeesCurrencies: CurrenciesConfig = {
  "en-gb": "GBP",
};

export const formatCurrency = (value: number, language: LanguageCode, fixedCurrency?: Currencies, precision = 0) => {
  const currencyFormatException = getCurrencyFormatException(value, language);
  if (currencyFormatException) return currencyFormatException;

  const currency = fixedCurrency ?? getCurrencyFromLanguage(language);
  const locale = getLocaleByLanguage(language);

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: precision,
  }).format(value);
};
